import View from './view.js'
import React from 'react'
import { useDataIsSubmitting, useDataFormat } from 'Simple/Data'
import { email as isValidEmail } from 'Data/validate.js'

export default function Logic(props) {
  let isSubmitting = useDataIsSubmitting({
    viewPath: props.viewPath,
    context: 'new_email',
  })

  let shouldDisable = useDataFormat({
    context: 'new_email',
    viewPath: props.viewPath,
    format: email =>
      email.type === 'existing'
        ? !email.contact_method_id
        : !isValidEmail(email.email.address),
  })

  return <View {...props} disabled={shouldDisable || isSubmitting} />
}
